// extracted by mini-css-extract-plugin
module.exports = {"label":"_9e6I0ftU"};